import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-transport-fee',
  templateUrl: './transport-fee.component.html',
  styleUrls: ['./transport-fee.component.css']
})
export class TransportFeeComponent implements OnInit {

  model = { 'transport_fee': '', 'trans_acct': '0' };
  oldTransFee;
  oldTransAcct;
  transAcctList = [];
  transDetail = '';
  // tax_list = [];
  // acct_number = '';
  // total_amount;

  // search_obj = {
  //   'placeholder': 'رقم الحساب/ اسم الحساب', 'class_name': 'longField',
  //   'table_list': [
  //     {
  //       'table_name': '`customer`', 'selected_no': 'customer_no',
  //       'field_list': ['customer_no', 'customer_name', 'customer_name_en']
  //     },
  //     {
  //       'table_name': '`supplier`', 'selected_no': 'supplier_no',
  //       'field_list': ['supplier_no', 'supplier_name', 'supplier_name_en']
  //     },
  //     {
  //       'table_name': '`bank_account`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'bank_acct_number', 'account_name', 'account_name_en']
  //     },
  //     {
  //       'table_name': '`sub_acct`', 'selected_no': 'acct_number',
  //       'field_list': ['acct_number', 'sub_acct_name', 'sub_acct_name_en']
  //     }
  //   ]
  // };

  Acct_Placeholder; Acct_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<TransportFeeComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
      
    this.getMessages(translate);
  }

  getMessages(translate) {
    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_Placeholder').subscribe((res: string) => {
      this.Acct_Placeholder = res;
    });
    // this.search_obj['placeholder'] = this.Acct_Placeholder;
    
    translate.get('Acct_Msg').subscribe((res: string) => {
      this.Acct_Msg = res;
    });
  }


  ngOnInit() {

    if (this.dialog_data!= undefined) {
      this.model = this.dialog_data[0];
      this.transAcctList = this.dialog_data[1]['transAcctList'];
      this.transDetail = this.dialog_data[1]['transDetail'];

      this.oldTransFee = this.dialog_data[0]['transport_fee'];
      this.oldTransAcct = this.dialog_data[0]['trans_acct'];
    }
     
    // let selObj;
    // let query = this.queryList.all_tax_types;
    // let obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.tax_list = data.data['list'];
    //     selObj = { 'acct_number': '0', 'tax_name_ar': 'اختر', 'tax_name_en': 'Select' };
    //     this.tax_list.unshift(selObj);
    //   });
  }

  onChangeAcct = function (search_result: object) {
    this.model['trans_acct'] = (search_result['no'] != '' ? search_result['no'] : '0');
  }

  // onChangeSearch = function (search_result: object) {
  //   // console.log(search_result);
  //   this.acct_number = search_result['no'];
  // }

  save() {
    if (isNaN(Number(this.model['transport_fee']))) {
      this.model['transport_fee'] = String(parseFloat(this.model['transport_fee']));
    }

    if (isNaN(Number(this.model['transport_fee']))) {
      this.model['transport_fee'] = '0';
    }

    if (Number(this.model['transport_fee']) > 0 && this.model['trans_acct'] == '0') {
      alert(this.Acct_Msg);
      return;
    }
    // let amount = Number(this.model['transport_fee']);
    // let tax_amount;
    // this.tax_list.forEach(element => {
    //   if (element.acct_number == this.model['tax_no']) {
    //     if (element.tax_perc != 0)
    //       tax_amount = amount * (element.tax_perc / 100);
    //     else if (element.tax_amount != 0)
    //       tax_amount = element.tax_amount;
    //     this.total_amount = tax_amount + amount;
    //     return false;
    //   }
    // });
    // if (tax_amount == undefined)
    //   this.total_amount = amount;
    this.dialog_data = {
      'transport_fee': this.model['transport_fee'],
      'trans_acct': this.model['trans_acct']
    };
    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    // this.dialog_data = this.dialog_data[0];
    // if (Number(this.model['transport_fee']) > 0 && this.model['trans_acct'] == '0')
    //   this.model['transport_fee'] = '0';

    this.dialog_data = {
      'transport_fee': this.oldTransFee,
      'trans_acct': this.oldTransAcct
    };
    this.dialogRef.close(this.dialog_data);
  }

}
